import { typeUniqueId } from "../../../../dataObjects/types"
import { submitEmailRequestToServer } from ".";
import { IEmailRequest } from "../../../../dataObjects/models/emailRequests";
import { generateEmailRequestForUserEmailAddressChangedTo } from "./userEmailAddressChangedTo";

/**
 * @function submitEmailRequestForUserEmailAddressChangedTo Generates amd submitsGenerates an email request to notify that the current
 *                            user's email address changed to a different email address
 * @param {typeUniqueId} userId The Id of the user who is the target of the email.
 * @param {string} newEmailAddress The new email address of the user (and the target of the email message).
 * @param {string} firstName The first name of the target of the email.
 * @param {string} lastName The last name of the target of the email.
 * @param {string} oldEmailAddress The old (prior) email address of the user.
 * @returns {void} A Promise with no return value
 */
export function submitEmailRequestForUserEmailAddressChangedTo(userId: typeUniqueId, oldEmailAddress: string, firstName: string, lastName: string, newEmailAddress: string): Promise<void> {
  return new Promise<void>(async (resolve, reject) => {
    try {
      // whether to display console logs (displayConsoleLogs && console.log statements)
      const displayConsoleLogs: boolean = false;

      displayConsoleLogs && console.log(`%c Entered submitEmailRequestForUserEmailAddressChangedTo()`, 'background: #055; color: #fff');

      // call method to generate the Account Verification email request, which will return the Email Request
      const emailRequest: IEmailRequest = await generateEmailRequestForUserEmailAddressChangedTo(userId, newEmailAddress.toLowerCase(), firstName, lastName, oldEmailAddress.toLowerCase());

      displayConsoleLogs && console.log(`%c In submitEmailRequestForUserEmailAddressChangedTo. Returned from call to generateEmailRequestForUserEmailAddressChangedTo. emailRequest: ${JSON.stringify(emailRequest)}`, 'background: #00B; color: #fff');

      // submit email request to the server
      await submitEmailRequestToServer(emailRequest);

      resolve();
    } catch (error: any) {
      reject(error);
    }
  });
}
